import type { MouseEventHandler } from 'react';
import { SummaryLabel } from 'src/components/accordion/SidebarAccordion.styled';

import { EyeIconButton } from './eyeIconButton/EyeIconButton';
import { AccordionLabel } from './MessagingTitle.styled';

interface MessagingTitleProps {
  label: string;
  isHighlighted?: boolean;
  hasError?: boolean;
  onClick: MouseEventHandler<HTMLButtonElement>;
}

export const MessagingTitle = (props: MessagingTitleProps) => {
  return (
    <AccordionLabel>
      <SummaryLabel $isError={props.hasError}>{props.label}</SummaryLabel>
      <EyeIconButton
        isHighlighted={props.isHighlighted}
        onClick={props.onClick}
      />
    </AccordionLabel>
  );
};
